import { render, staticRenderFns } from "./LangSelection.vue?vue&type=template&id=5a76ffae&scoped=true&"
import script from "./LangSelection.vue?vue&type=script&lang=ts&"
export * from "./LangSelection.vue?vue&type=script&lang=ts&"
import style0 from "./LangSelection.vue?vue&type=style&index=0&id=5a76ffae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76ffae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
